<template>
  <div class="form-group row">
    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Número Guia:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtro.numeroGuia">
      </div>

      <div class="col-sm-2 text-sm-right">
        <label>Número Protocolo:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <the-mask :key="key" :mask="['##/######/####']" type="text" class="form-control" v-model="filtro.numeroProcesso"/>
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Município:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtro.cidadeRemetente">
      </div>

      <div class="col-sm-2 text-sm-right">
        <label>Interessado:</label>
      </div>
      <div class="col-md-4 col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtro.interessados">
      </div>
    </div>

    <div class="col-11 row">
      <div class="col-sm-2 text-sm-right">
        <label>Assunto:</label>
      </div>
      <div class="col-sm-10 mb-3">
        <input type="text" class="form-control" v-model="filtro.assunto">
      </div>
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="pesquisar(1)"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar()"> Limpar </button>
    </div>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import VirtusService from '@/services/VirtusService'

import { mapState } from 'vuex'

export default {
  name: 'filtroPesquisaAReceber',

  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      key: true,
      filtroDefault: {
        numeroProcesso: '',
        numeroGuia: '',
        usuarioEnvio: '',
        cidadeRemetente: '',
        assunto: '',
        interessados: '',
        offset: 1,
        range: this.rowsNumber,
        armazenado: false,
        arquivado: false,
        anexado: false,
        eliminado: false,
        apensado: false,
        emTramite: true
      }
    }
  },

  computed: {
    ...mapState({
      filtro: state => state.filtroPesquisaAReceber
    })
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina, action = '') => {
      this.trocaDePagina(numeroPagina, action)
    })

    this.service = new VirtusService()
    this.limpar()
  },

  methods: {
    pesquisar (page = 1, action = '') {
      this.filtro.offset = page

      this.service.consultarNoSetor(this.filtro).then(res => {
        eventBus.$emit(this.eventBusDataName, res, action)
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.$store.commit('MUT_FILTRO_PESQUISA_A_RECEBER', {
        ...this.filtroDefault,
        tipoIdentificador: 'ID',
        identificador: dadosSessao.sessao.idDepartamento
      })
      this.key = !this.key
      this.pesquisar(1, 'RESET_SELECTED')
    },

    trocaDePagina (numeroPagina, action) {
      this.pesquisar(numeroPagina, action)
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>

<style scoped lang="scss">

.row {
  margin-top: 2px;
}
</style>
